
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-shopping",
      function () {
        return require("private-next-pages/personal-shopping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-shopping"])
      });
    }
  